import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css'; // CSS Module import

import logoImg from '../../assets/login_Logo.svg'; // 로고 이미지 import

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기

const Login = ({ setIsLoggedIn }) => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // console.log(`Attempting to log in with login_id: ${loginId} and password: ${password}`);
  
      // 요청 전 데이터 확인
      const payload = {
        login_id: loginId,
        password: password,
      };
      // console.log('Sending payload to server:', payload);
  
      // 로그인 요청
      const response = await axios.post(`${apiUrl}/accounts/login/`, payload, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
  
      // console.log('Server response:', response.data);
  
      // 로그인 성공 시 JWT 토큰 저장
      const { access, refresh, user } = response.data;
      if (access && refresh && user) {
        // console.log('Login successful, saving tokens...', { access, refresh });
  
        localStorage.setItem('accessToken', access);
        localStorage.setItem('refreshToken', refresh);
        localStorage.setItem('user_id', user.id);  // user.id 저장
        localStorage.setItem('username', user.username); // user.username 저장
        console.log('User ID saved:', user.id);
        console.log('Username saved:', user.username);  // 저장된 username 콘솔 출력
  
        // 토큰 저장 후 대시보드로 리다이렉트
        setIsLoggedIn(true);
        navigate('/main');
        navigate('/main');
        navigate('/main');

        // 액세스 토큰 만료 타이머 설정
        const decodedToken = JSON.parse(atob(access.split('.')[1]));
        const expirationTime = decodedToken.exp * 1000; // `exp`는 초 단위이므로 밀리초로 변환
        const currentTime = new Date().getTime();
        const timeLeft = expirationTime - currentTime;

        if (timeLeft > 0) {
          setTimeout(() => {
            setIsLoggedIn(false);
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user_id');
            localStorage.removeItem('username');
            navigate('/login'); // 만료 시 로그인 페이지로 이동
          }, timeLeft);
        }
      } else {
        // console.error('Login failed: Tokens or user information are missing in the response');
        setMessage('로그인에 실패했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      if (error.response) {
        console.error('Error status code:', error.response.status);
        console.error('Error response data:', error.response.data);
      } else {
        console.error('Error message:', error.message);
      }
      const errorMessage = error.response?.data?.error || '로그인에 실패했습니다. 다시 시도해주세요.';
      setMessage(errorMessage);
    }
  };
  
  
  

  const handleSignupRedirect = () => {
    navigate('/register');
  };

  return (
    <div className={styles.loginContainer}>
      <img src={logoImg} alt="로고" className={styles.logo} />

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <p >아이디</p>
          <input
            type="text"
            id="loginId"
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
            placeholder="gloupID"
            required
            className={styles.input}
          />
        </div>

        <div className={styles.formGroup}>
          <p>비밀번호</p>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="gloupPW"
            required
            className={styles.input}
          />
        </div>

        <button type="submit" className={styles.submitButton}>로그인</button>
      </form>

      <div className={styles.helperLinks}>
        <p>
          아직 글로가 아니신가요?{' '}
          <button onClick={handleSignupRedirect} className={styles.linkButton}>
            회원가입하기
          </button>
        </p>
        {/* <div className={styles.helperpw}>
        <p >
          비밀번호를 잊으셨나요?{' '}
          <button className={styles.linkButton}>비밀번호 찾기</button>
        </p>
        </div> */}
      </div>

      {message && <p className={styles.errorMessage}>{message}</p>}
    </div>
  );
};

export default Login;
